import { FaWhatsapp } from "react-icons/fa";

const WhatsAppFloatButton = () => {
  const phoneNumber = "918269341122";
  const message = "Thank you for contacting Ease Margin! Please let us know how we can help you.";
  const WhatsappIcon = FaWhatsapp as unknown as React.FC<any>;

  return (
    <a
      href={`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 1000,
      }}
    >
      <div
        style={{
          width: 56,
          height: 56,
          borderRadius: "50%",
          backgroundColor: "#25D366",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "0 4px 12px rgba(76, 52, 52, 0.3)",
          cursor: "pointer",
        }}
      >
        <WhatsappIcon size={30} color="#fff" />
      </div>
    </a>
  );
};
export default WhatsAppFloatButton;